import { find, get } from 'lodash';
import React, { memo, useCallback, useMemo } from 'react';
import classnames from 'classnames';
import { useMutation, useQuery } from 'react-apollo';
import { defaultErrorMessage, handleFormErrors } from '../../../common/errors';
import Icon from '../../../common/components/utils/Icon';
import { useTranslation } from '../../../common/components/utils/Translations';
import useCurrentUser from '../../../common/data/hooks/useCurrentUser';
import Notifications from '../../../common/utils/Notifications';
import styles from '../../../common/utils/SocialLoginButton/SocialLoginButtonView.scss';
import hasActivatedMobileAppGql from './data/hasActivatedMobileApp.graphql';
import sendMobileAppInvitationGql from './data/sendMobileAppInvitation.graphql';
const EMAIL_CONTACT_KIND_ID = 1;
const getPrimaryEmail = (contacts) => get(find(contacts, ({ type }) => (type === null || type === void 0 ? void 0 : type.id) === EMAIL_CONTACT_KIND_ID), 'contact', '');
const MobileApps = () => {
    const { t } = useTranslation();
    const { me: currentUser } = useCurrentUser();
    const [sendMobileAppInvitation, { loading }] = useMutation(sendMobileAppInvitationGql);
    const { data: activationData, loading: activationLoading, } = useQuery(hasActivatedMobileAppGql, { fetchPolicy: 'network-only' });
    const hasActivatedMobileApp = get(activationData, 'hasActivatedMobileApp', false);
    const primaryEmail = useMemo(() => getPrimaryEmail((currentUser === null || currentUser === void 0 ? void 0 : currentUser.contacts) || []), [currentUser]);
    const fullName = get(currentUser, 'fullName', '');
    const isSendInvitationDisabled = loading || !primaryEmail;
    const handleSendInvitationClick = useCallback(async () => {
        const { data } = await handleFormErrors(sendMobileAppInvitation(), t);
        if (!(data === null || data === void 0 ? void 0 : data.sendMobileAppInvitation)) {
            Notifications.error(t('Error'), t(defaultErrorMessage), t);
            return;
        }
        Notifications.success(t('Invitation sent to #{fullName} (#{email})', {
            fullName,
            email: primaryEmail,
        }), '', t);
    }, [fullName, primaryEmail, sendMobileAppInvitation, t]);
    return (<>
      {!activationLoading && !hasActivatedMobileApp && (<h6 data-cy="mobile-apps-not-activated-message">
          {t('You are not using the Edana mobile app. Please send yourself an invitation to install the app and activate it')}
        </h6>)}
      <button className={classnames(styles.m3, 'btn btn-default btn-raised btn-labeled')} data-cy="mobile-apps-send-invitation-button" disabled={isSendInvitationDisabled} type="button" onClick={handleSendInvitationClick}>
        <b className={styles.imageContainer}>
          <Icon className="text-default" name="mobile2"/>
        </b>
        <span className={styles.title}>
          {t('Send me an invitation to Edana Mobile App')}
        </span>
      </button>
      <p className="mt-10" data-cy="mobile-apps-primary-email-copy">
        {t('This will be sent to your primary email address, being #{email}.', {
        email: primaryEmail,
    })}
      </p>
    </>);
};
export default memo(MobileApps);
